<template>
  <div>

  </div>
</template>

<script>
export default {
    name:"Jumpapplet",
    data(){
        return{

        }
    },
    mounted(){
        console.log(window.location.href)
         window.location.href="https://wxaurl.cn/5KezWP3yDBv";
        //  window.location.herf("https://www.baidu.com");
    },




}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/pages/qcwy/Jumpapplet.vue